import React from "react";

import styles from "./ChartCard.module.css";

export interface ChartCardProps {
  title?: string;
  // accessible name for the section; falls back to `title`
  ariaLabel?: string;
  // "column" stacks the title above headerExtra (e.g. a legend); "row" keeps them inline
  headerLayout?: "row" | "column";
  // lets custom header content occupy the entire card width
  fullWidthHeader?: boolean;
  // slot beside/below the title — a legend, a metric Select, etc.
  headerExtra?: React.ReactNode;
  // slot on the right — date picker, download button, etc.
  controls?: React.ReactNode;
  // applied to the body wrapper, used to size the chart area
  bodyClassName?: string;
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  ariaLabel,
  headerLayout = "row",
  fullWidthHeader = false,
  headerExtra,
  controls,
  bodyClassName,
  children,
}) => {
  const hasHeader = Boolean(title || headerExtra || controls);

  return (
    <section className={styles.card} aria-label={ariaLabel ?? title}>
      {hasHeader && (
        <header
          className={`${styles.header} ${
            fullWidthHeader ? styles.fullWidthHeader : ""
          }`}
        >
          <div
            className={`${styles.titleGroup} ${
              headerLayout === "column" ? styles.columnLayout : styles.rowLayout
            }`}
          >
            {title && <h2 className={styles.title}>{title}</h2>}
            {headerExtra && (
              <div className={styles.headerExtra}>{headerExtra}</div>
            )}
          </div>
          {controls && <div className={styles.controls}>{controls}</div>}
        </header>
      )}
      <div className={bodyClassName}>{children}</div>
    </section>
  );
};

export default ChartCard;
